<template>
  <div class="flex flex-col gap-2 mb-2 h-max pb-6">
    <LottieAnimation
      ref="anim"
      :animationData="completedIntegration"
      :autoPlay="true"
      :loop="false"
      :speed="1"/>
    <h2 class="text-center font-medium text-xl -mt-4"> הכל מוכן לתשלומים!</h2>
    <span class=" text-center">מעכשיו הלקוחות שלך יכולים לשלם בקלות ובצורה מאובטחת.</span>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import completedIntegrationData from '../../../../../assets/animations/complete-integration.json';
import {LottieAnimation} from "lottie-web-vue"

const completedIntegration = completedIntegrationData;
defineProps({
  provider: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['finish']);

const isLoading = ref<boolean>(true);
const showSuccess = ref<boolean>(false);

setTimeout(() => {
  isLoading.value = false;
  showSuccess.value = true;
  emit('finish');
}, 4000);

</script>

<style scoped lang="scss">

</style>
